var _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveServing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.942 21.26h2.823v4.174H.942zm16.304 1.052-6.081 1.452q-.44.105-.892.105h-1.42c-.622 0-1.234.123-1.817.366l-2.33.968v-4.198c.13-.102.272-.201.419-.275l4.807-2.42c.386-.194.804.199.695.652a.56.56 0 0 1-.234.34l-1.505.968a.55.55 0 0 0-.219.587c.056.227.242.386.455.386 8.551.006 7.927-.013 8.075.012.245.058.395.287.395.535a.55.55 0 0 1-.348.522m3.9-2.671c-.161.355-.484.576-.842.576-7.913-.032-1.52-.014-9.432-.017.687-.448.919-1.43.513-2.193-.375-.708-1.167-.986-1.842-.647-5.19 2.614-4.93 2.464-5.22 2.673a6 6 0 0 0-.24.184H3.74c-.356 0-.677-.218-.838-.568L1.24 16.043h21.528zM22.955 14c.05.55-.4 1-.952 1H1.997c-.552 0-1.002-.45-.952-1C1.55 8.395 6.262 4 12 4s10.45 4.394 10.955 10",
    fill: "current"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 2,
    fill: "current"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 14,
    r: 5.5,
    fill: "current",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 14.313 1.563 1.562 3.125-3.125",
    stroke: "#fff",
    strokeWidth: 0.781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveServing);
export default __webpack_public_path__ + "static/media/activeServing.1de5d5e1edebbb2bfeb637837ecef143.svg";
export { ForwardRef as ReactComponent };